export const TITLES = {
  addComment: "Добавить комментарий",
  createTask: "Создать тикет",
  edit: "Редактировать",
};

export const BUTTON_TITLES = {
  add: "+ Добавить тикет",
};

export const FILTER_TITLES = {
  comment: "Комментарий",
  description: "Описание",
  tag: "Тег",
};


export const ERROR_TITLE = {
  fieldError: "Поле должно быть заполнено"
}